module.exports = __webpack_public_path__ + "img/change.be61dd54.svg";